import React from 'react';

const UnderlineText = ({ stroke, ...props }) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.3125 15.1875H15.6875"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.9375V8.4375C5 9.63097 5.47411 10.7756 6.31802 11.6195C7.16193 12.4634 8.30653 12.9375 9.5 12.9375C10.6935 12.9375 11.8381 12.4634 12.682 11.6195C13.5259 10.7756 14 9.63097 14 8.4375V3.9375"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnderlineText;
